'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleToNumber = exports.serializerQueryParams = exports.createElement = exports.doesStringContainAny = exports.getElements = exports.getElement = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getElement = exports.getElement = function getElement(selector) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$context = _ref.context,
      context = _ref$context === undefined ? document : _ref$context;

  return context.querySelector(selector);
};

var getElements = exports.getElements = function getElements(selector) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? document : _ref2$context,
      _ref2$asArray = _ref2.asArray,
      asArray = _ref2$asArray === undefined ? true : _ref2$asArray;

  var items = context.querySelectorAll(selector);

  return asArray ? Array.from(items) : items;
};

var doesStringContainAny = exports.doesStringContainAny = function doesStringContainAny(str) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return items.some(function (i) {
    return str.includes(i);
  });
};

var createElement = exports.createElement = function createElement(tag) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var el = document.createElement(tag);
  Object.entries(options).forEach(function (_ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    el.setAttribute(key, value);
  });

  return el;
};

var serializerQueryParams = exports.serializerQueryParams = function serializerQueryParams(params) {
  return Object.entries(params).map(function (pair) {
    return pair.map(encodeURIComponent).join('=');
  }).join('&');
};

var styleToNumber = exports.styleToNumber = function styleToNumber(str) {
  return parseInt(str, 10);
};